// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pre-read-label_wrapper__3jg1R"};